// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__wiX_2","titleWrapper":"styles_titleWrapper__P7HnC","linksWrapper":"styles_linksWrapper__3L_4Z","linkWrapper":"styles_linkWrapper__FUPI1"};